import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_121: FaireProductEntity = {
  token: "starter_collection_121",
  type: "product",
  name: "Ghia Berry Aperitif",
  brandName: "Ghia",
  imageUrl:
    '"https://cdn.faire.com/fastly/f12a4c85aac39bc6ec51438e0548fbff9821ee49d929707455df58b1b01c0b5b.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1079',
  priceDollars: 35,
  msrpDollars: 70,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
